import {useEffect, useState} from 'react';

export const useLocalState = (
  key: string,
  initial?: string,
): [string | undefined | null, (v?: string) => void] => {
  const [state, setState] = useState<string | undefined | null>(
    initial ?? window.localStorage.getItem(key),
  );

  useEffect(() => {
    const value = localStorage.getItem(key);
    setState(value);
  }, [key]);

  const set = (v?: string) => {
    if (v === undefined) localStorage.removeItem(key);
    else localStorage.setItem(key, v);
    setState(v);
  };

  return [state, set];
};
